module.exports = __webpack_public_path__ + "static/scopriabitareco_experiences_smartphoneetablet-7c642eafaf43a711044770949ad4a178.jpg";